import React from 'react';

import styles from '../style';

import {
  putthida,
  wei,
  juhua,
  jiayu,
  zhiqi,
  michael,
} from '../assets/founders';

const OurTeam = () => {
  const teamMembers = [
    {
      name: 'Dr. Wei Cheng',
      role: 'Co-Founder',
      image: wei,
      bio: 'Wei is an expert in Smart Transportation systems. He enjoys designing algorithms and protocols and making them into reality.',
    },
    {
      name: 'Dr. Juhua Hu',
      role: 'Co-Founder',
      image: juhua,
      bio: 'Juhua is an expert in Machine Learning and Computer Vision. She is addicted to turning data into actionable insights for the well-being of people’s lives.',
    },
    {
      name: 'Jiayu Li',
      role: 'Co-Founder',
      image: jiayu,
      bio: "Jiayu's expertise is in the areas of computer vision, deep learning, and data science. Her research and expertise lie in applying state-of-the-art technology to address real-world problems.",
    },
    {
      name: 'Putthida Samrith',
      role: 'Co-Founder',
      image: putthida,
      bio: 'Putthida specializes in urban technology, with a focus on developing routing algorithms for real-world transportation and street data collection challenges. Her work centers on building practical, user-focused solutions that improve how cities operate.',
    },
    {
      name: 'Dr. Zhi-Qi Cheng',
      role: 'Key Member',
      image: zhiqi,
      bio: 'Zhi-Qi Cheng is an expert in Multimedia and Computer Vision, with a focus on autonomous driving and video surveillance. He is passionate about transforming data into intelligent systems that enhance safety and efficiency in real-world environments.',
    },
    {
      name: 'Michael Robinson',
      role: 'Business Development Advisor',
      image: michael,
      bio: 'Michael was an SVP of Data and Insight at EA. He also worked at Amazon, Microsoft, and McKinsey in business development leadership roles. Michael was the co-founder and CEO of RenRen Media and IceBreaker.',
    },
  ];

  return (
    <section
      className={`${styles.flexCenter} flex-col my-4 items-center text-center bg-gray-100 py-8`}
    >
      <h2 className={`${styles.heading2} text-gradient`}>
        Meet the People Behind Ai4Curb
      </h2>

      <p className={`${styles.paragraph} max-w-[770px] mt-4`}>
        We bring together expertise in transportation, machine learning,
        computer vision, software development, and business strategy to
        build practical technology for smarter cities.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8 mx-4 max-w-[1200px] w-full">
        {teamMembers.map((member, index) => (

          <div
            key={member.name}
            className="w-full"
          >
            <div
              className="
                bg-white
                rounded-2xl
                border border-gray-200
                p-6
                h-full
                flex flex-col
                text-left
                transition-all
                duration-300
                hover:-translate-y-1
                hover:shadow-lg
              "
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-28 h-28 rounded-2xl object-cover mb-5"
              />

              <h3 className="text-xl font-semibold text-gray-900">
                {member.name}
              </h3>

              <p className="text-sm font-medium text-green-700 mt-1">
                {member.role}
              </p>

              <div className="w-10 h-[2px] bg-gray-200 my-4" />

              <p className="text-gray-500 text-sm leading-6">
                {member.bio}
              </p>
            </div>
          </div>
          
        ))}
      </div>
    </section>
  );
};

export default OurTeam;